export const BASE_URL_AUTH =
  process.env.REACT_APP_ENV === "local"
    ? process.env.REACT_APP_AUTH_BACKEND_URL_LOCAL
    : process.env.REACT_APP_ENV === "staging"
      ? process.env.REACT_APP_AUTH_BACKEND_URL_STAGING
      : process.env.REACT_APP_AUTH_BACKEND_URL_PROD;
export const BASE_URL_USER =
  process.env.REACT_APP_ENV === "local"
    ? process.env.REACT_APP_USER_BACKEND_URL_LOCAL
    : process.env.REACT_APP_ENV === "staging"
      ? process.env.REACT_APP_USER_BACKEND_URL_STAGING
      : process.env.REACT_APP_USER_BACKEND_URL_PROD;
export const BASE_URL_SEARCH =
  process.env.REACT_APP_ENV === "local"
    ? process.env.REACT_APP_SEARCH_BACKEND_URL_LOCAL
    : process.env.REACT_APP_ENV === "staging"
      ? process.env.REACT_APP_SEARCH_BACKEND_URL_STAGING
      : process.env.REACT_APP_SEARCH_BACKEND_URL_PROD;
export const BASE_URL_MEDIA =
  process.env.REACT_APP_ENV === "local"
    ? process.env.REACT_APP_MEDIA_BACKEND_URL_LOCAL
    : process.env.REACT_APP_ENV === "staging"
      ? process.env.REACT_APP_MEDIA_BACKEND_URL_STAGING
      : process.env.REACT_APP_MEDIA_BACKEND_URL_PROD;
export const BASE_URL_ACTIVITY =
  process.env.REACT_APP_ENV === "local"
    ? process.env.REACT_APP_ACTIVITY_BACKEND_URL_LOCAL
    : process.env.REACT_APP_ENV === "staging"
      ? process.env.REACT_APP_ACTIVITY_BACKEND_URL_STAGING
      : process.env.REACT_APP_ACTIVITY_BACKEND_URL_PROD;
export const BASE_URL_SUBSCRIPTION =
  process.env.REACT_APP_ENV === "local"
    ? process.env.REACT_APP_SUBSCRIPTION_BACKEND_URL_LOCAL
    : process.env.REACT_APP_ENV === "staging"
      ? process.env.REACT_APP_SUBSCRIPTION_BACKEND_URL_STAGING
      : process.env.REACT_APP_SUBSCRIPTION_BACKEND_URL_PROD;
export const BASE_URL_NOTIFICATION =
  process.env.REACT_APP_ENV === "local"
    ? process.env.REACT_APP_NOTIFICATION_BACKEND_URL_LOCAL
    : process.env.REACT_APP_ENV === "staging"
      ? process.env.REACT_APP_NOTIFICATION_BACKEND_URL_STAGING
      : process.env.REACT_APP_NOTIFICATION_BACKEND_URL_PROD;
export const BASE_URL_LANDING =
  process.env.REACT_APP_ENV === "local"
    ? process.env.REACT_APP_LANDING_URL_LOCAL
    : process.env.REACT_APP_ENV === "staging"
      ? process.env.REACT_APP_LANDING_URL_STAGING
      : process.env.REACT_APP_LANDING_URL_PROD;

export const APPSYNC_API_KEY =
  process.env.REACT_APP_ENV === "local"
    ? process.env.REACT_APP_APPSYNC_API_KEY_LOCAL
    : process.env.REACT_APP_ENV === "staging"
      ? process.env.REACT_APP_APPSYNC_API_KEY_STAGING
      : process.env.REACT_APP_APPSYNC_API_KEY_PROD;

export const STRIPE_KEY =
  process.env.REACT_APP_ENV === "local"
    ? process.env.REACT_APP_STRIPE_KEY_LOCAL
    : process.env.REACT_APP_ENV === "staging"
      ? process.env.REACT_APP_STRIPE_KEY_STAGING
      : process.env.REACT_APP_STRIPE_KEY_PROD;
